import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OphDrawerComponent} from './oph-drawer.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [OphDrawerComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [OphDrawerComponent],
})
export class OphDrawerModule {}
